import { ref, getDownloadURL, getBlob } from 'firebase/storage';
import { storage, storageErrorMessage } from '@/cloud/config/firebaseConfig';
import { COLLECTION, MAX_DOWNLOAD_SIZE_BYTES } from '@/utils/constant';

const projectRef = (path) => ref(storage, `/${COLLECTION.PROJECT}/${path}`);

export const getImgURL = async (filename) => {
  let url;
  if (filename) {
    try {
      const imageRef = projectRef(`images/${filename}`);
      url = await getDownloadURL(imageRef).then((url) => url.toString());
    } catch (error) {
      storageErrorMessage(getImgURL.name, error, filename);
    }
  }
  return url;
};

export const getDescription = async (filename) => {
  let fileText;
  if (filename) {
    try {
      const descriptionRef = projectRef(`descriptions/${filename}`);
      fileText = await getBlob(descriptionRef, MAX_DOWNLOAD_SIZE_BYTES).then(
        (blob) => blob.text()
      );
    } catch (error) {
      storageErrorMessage(getDescription.name, error, filename);
      alert('화면 구성을 위한 임시 페이지로,\n현재 내용이 없는 상태입니다.');
    }
  }
  return fileText;
};
